import React from 'react'

export type AddonSettings = {
  addonType: 'prepend' | 'append'
  addon: React.ReactNode
}

export const InputAddon: React.VFC<AddonSettings> = ({ addonType, addon }) => {
  return (
    <div className={`input-group-${addonType}`}>
      <div className="input-group-text">{addon}</div>
    </div>
  )
}
